import React from 'react'
import Result from '../../pages-partial/ResultManagement'

const ResultManagement = () => {
  return (
    <div><Result /></div>
  )
}

export default ResultManagement